import { render, staticRenderFns } from "./VendorNotes.vue?vue&type=template&id=47781574"
import script from "./VendorNotes.vue?vue&type=script&lang=js"
export * from "./VendorNotes.vue?vue&type=script&lang=js"
import style0 from "./VendorNotes.vue?vue&type=style&index=0&id=47781574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports